
import Vue from "vue";
import BaseButton from "@/components/buttons/BaseButton.vue";
import {delayFunctionCall, HelperFunctions} from "@/scripts/Common/HelperFunctions";

export default Vue.extend({
  components: {BaseButton},
  data: function () {
    return {
      isActive: false,
      TicketUrl: "",
      copyConfirmationFlashing: false,
    };
  },
  methods: {
    Show: function(ticketUrl : string){
      this.TicketUrl = ticketUrl;
      this.isActive = true;
    },
    Hide: function (){
      this.isActive = false;
    },
    Confirm: function (){
      this.Hide();
      this.$emit("confirmed");
    },
    OnCopyClick: function (){
      this.copyConfirmationFlashing = true; // Flash the text field to indicate that the text has been copied
      HelperFunctions.CopyText(this.TicketUrl);
      delayFunctionCall(() => {
        this.copyConfirmationFlashing = false;
      }, 500);
    }
  },
});
